import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

// « montee » : 250 ms, cubic-bezier(.16,1,.3,1), 12 px.
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      // minHeight (pas height) : avec une hauteur fixe, le contenu qui déborde
      // ignore le padding bas du <main> et le dernier échange passe sous la barre d'onglets mobile.
      style={{ minHeight: '100%' }}
    >
      {children}
    </motion.div>
  );
}
